


































































































































import { ScheduleSlotRangeItem } from '@bookings/interfaces/schedule';
import { SlotPriceCategory } from '@bookings/interfaces/slot-price-category';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VueSelecto } from 'vue-selecto';
@Component({
  name: 'schedule-slot-range-selector',
  components: {
    'vue-selecto': VueSelecto,
  },
})
export default class ScheduleSelector extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly slotPriceCategories: SlotPriceCategory[];

  @Prop({
    type: Array,
    default() {
      return null;
    },
  })
  readonly value: ScheduleSlotRangeItem[];

  get model(): ScheduleSlotRangeItem[] {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  selectedCategory = null;

  getCellStyle(slotPriceCatId) {
    if (slotPriceCatId) {
      const cat = this.slotPriceCategories.find(
        slotCategory => slotCategory?.id === slotPriceCatId,
      );

      if (cat?.color) {
        return {
          'background-color': cat.color,
        };
      }
    }

    return {
      'background-color': 'rgba(0, 0, 0, 0.1)',
    };
  }

  getCatButtonStyle(slotPriceCatId) {
    const cat = this.slotPriceCategories.find(slotCategory => slotCategory?.id === slotPriceCatId);
    const color = cat?.color || null;
    const opacity = cat?.id === this.selectedCategory ? 1 : 0.6;
    return {
      'border-width': '0px',
      'background-color': color + ' !important',
      opacity: opacity,
    };
  }

  onSelect(e) {
    const addedRemoved = e.added.concat(e.removed);
    addedRemoved.forEach(el => {
      const day = el.getAttribute('data-day');
      const time = el.getAttribute('data-time');
      this.changeModel(day, time, this.selectedCategory);
    });
  }

  changeSelectedCategory(slotCategoryId) {
    this.selectedCategory = slotCategoryId;
  }

  changeModel(day, time, categoryId) {
    this.model = this.model.map(scheduleSlotRange => {
      if (scheduleSlotRange.start_time === time) {
        scheduleSlotRange[day] = categoryId;
      }
      return scheduleSlotRange;
    });
  }
}
